<template>
    <CarouselGrid class="tag-page-profiles-list" :items="carouselItems">
        <template #slide="{item}">
            <ProfileCard v-if="item.id" :profile="formatProfile(item)" :link-href="$withLocalePrefix(item.url)" />
        </template>
    </CarouselGrid>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {ProfileCard} from '#components';
    import type {FreelancerProfile} from '@api';
    import CarouselGrid from '~/components/CarouselGrid.vue';
    import {formatProfile} from '~/composables/acquisition/useAcquisitionPage';

    const {profiles} = defineProps<{profiles?: FreelancerProfile[]}>();

    const carouselItems = ref(profiles as any[]);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .tag-page-profiles-list {
        .profile-card {
            height: 100%;
        }
        @include mq.screen_md() {
            .swiper-slide {
                padding-bottom: var(--joy-core-spacing-3);
            }
        }
    }
</style>
